import { ActivityInitialState } from "../../../types/hr/hrInterface";
import { HrActionTypes, HrActions } from "../../actionTypes/hr/hrActionTypes";

const initialState: ActivityInitialState = {
  activityData: {
    id: 0,
    user_id: 0,
    check_in: "",
    check_out: "",
    total_work_duration: "",
    overtime_hours: null,
    in_geo_location: null,
    out_geo_location: null,
    in_device_info: null,
    out_device_info: null,
    status: "",
    is_late: false,
    approved: false,
    remarks: "",
    createdAt: "",
    updatedAt: "",
  },
};

export default function hrActivityReducer(state = initialState, action: HrActionTypes): ActivityInitialState {
  switch (action.type) {

    case HrActions.SET_ACTIVITY:
      return {
        ...state,
        activityData: action.payload,
      };

    default:
      return state;
  }
}
